// extracted by mini-css-extract-plugin
module.exports = {"insightsIconContainer":"rg_RrkqT","scenarioIconWrapper":"fqHKjYge"};